import {Injectable} from '@angular/core';
import {CustomHttp} from '../../core/http-custom/http-custom.service';
import {Observable} from 'rxjs';

@Injectable()
export class DomainService {

  constructor(
    private _http: CustomHttp
  ) {
  }

  public getCurrentDomain(): Observable<any> {
    return this._http.get(`/apps/umng/api/domain`);
  }

}
